import { render, staticRenderFns } from "./NewProjectCategory.vue?vue&type=template&id=59dd1b08&scoped=true&"
import script from "./NewProjectCategory.vue?vue&type=script&lang=js&"
export * from "./NewProjectCategory.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectCategory.vue?vue&type=style&index=0&id=59dd1b08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dd1b08",
  null
  
)

export default component.exports